// LIBELLULE events filters
// v1.1 - feb 21 - @shess

// import external dependencies
import "imagesloaded/imagesloaded.pkgd.js";
import "isotope-layout/dist/isotope.pkgd.js";
import Isotope from "isotope-layout";

/*==========================================================
=             Initialization                               =
==========================================================*/
(function init($) {

  'use strict';
  //init main func on doc ready
  $(document).ready(initPage);

  /*==========================================================
  =             global vars           					   =
  ==========================================================*/

  var $container = $('.js-wall'),
    $filter = $('.js-filtersGroup'),
    $filterLabel = $('.js-filtersGroupLabel'),
    $filterItem = $('.js-filtersGroupItem'),
    $filterReset = $('.js-filtersReset'),
    hashFilter = getHashFilter(),
    filters = {};


  /*===============================================================
  =       Main Func: initialize values and call initializers      =
  ===============================================================*/
  function initPage() {

    // Disable position animation for isotope
    Isotope.prototype._positionItem = function (item, x, y) {
      item.goTo(x, y);
    };

    ///////////////////////////
    // Init Isotope	    	 //
    ///////////////////////////
    $container.imagesLoaded(function () {
      $container.isotope({
        itemSelector: ".js-filter-item",
        layoutMode: "fitRows",
        percentPosition: true,
        resizable: false,
        masonry: {
          columnWidth: ".js-filter-item",
        },
      });
    });

    // watch url change
    $(window).on('hashchange', onHashchange);
    //trigger event handler to init Isotope
    onHashchange();

    // Init Filters Dropdown
    filterDropdown();
    // Init Filters VIEWS (.js-collection)
    filterViews();

    // Init Filters Reset
    resetBtn();

  }

  /*==========================================================
  =        Declare Tools & Functions                         =
  ==========================================================*/

  // Change Views
  function filterViews() {
    let $collection = $('.js-collection'),
      $collectionViewBtns = $('.js-viewBtnSwitch'),
      $collectionViews = $('[data-collectionView]');

    $collectionViewBtns.on('click', function () {
      const $this = $(this),
        view = $this.data('view');
      // btn state
      $collectionViewBtns.removeClass('is-active');
      $this.addClass('is-active');
      // view switch
      $collectionViews.hide();
      $collection.find(`[data-collectionView='${view}']`).show();
      // relayout isotope
      $container.isotope("layout");
    });
  }

  // Dropdown/Filter  on click
  function filterDropdown() {

    $filterItem.on("click", function () {

      var $this = $(this),
        group = $this.parents('.js-filtersGroup').attr('data-filter-group');

      // create array for filter group, if not there yet
      var filterGroup = filters[group];
      if (!filterGroup) {
        filterGroup = filters[group] = [];
      }

      // Add/remove filter to group
      var index = $.inArray($this.attr('data-filter'), filters[group]);

      // if filters not present
      if (index === -1) {
        // only one choice per group, empty first
        filterGroup.length = 0;
        // then add filter to group
        filterGroup.push($this.attr('data-filter'));
      } else {
        // remove filter from group
        filterGroup.splice(index, 1);
      }

      // Update filters isotope
      hashFilter = getComboFilter();

      // encode url with filters
      location.hash = 'filters=' + encodeURIComponent(hashFilter);

      // console.log(JSON.stringify(filters, null, 2));
    });

  }


  /////////////////////////////////////////////
  // Check filters group if has active filters //
  /////////////////////////////////////////////

  function checkFiltersGroup() {
    // All dropdown check
    $filter.each(function () {
      var $this = $(this),
        $activeFilter = $this.find('.js-filtersGroupItem.is-active'),
        $activeFilterNum = $this.find('.js-filtersGroupItem.is-active').length,
        $dropdownBtn = $this.prev('button'),
        $dropdownBtnText = $this.prev('button').find($filterLabel);

      // if active filterItems
      if ($activeFilterNum > 0) {
        $dropdownBtn.addClass('is-active');
        $dropdownBtnText.text($activeFilter.text());
      } else {
        $dropdownBtn.removeClass('is-active');
        // reset to default label
        $dropdownBtnText.text($dropdownBtnText.attr('data-label'));
      }

    });
  }

  ////////////////////////////////////////////////////////
  // Combo filters for data-filter-group				    //
  ////////////////////////////////////////////////////////
  function getComboFilter() {
    var combo = [];
    for (var prop in filters) {
      var group = filters[prop];
      if (!group.length) {
        // no filters in group, carry on
        continue;
      }
      // add first group
      if (!combo.length) {
        combo = group.slice(0);
        continue;
      }
      // add additional groups
      var nextCombo = [];
      // split group into combo: [ A, B ] & [ 1, 2 ] => [ A1, A2, B1, B2 ]
      for (var i = 0; i < combo.length; i++) {
        for (var j = 0; j < group.length; j++) {
          var item = combo[i] + group[j];
          nextCombo.push(item);
        }
      }
      combo = nextCombo;
    }
    var comboFilter = combo.join(', ');

    return comboFilter;
  }

  ///////////////////////////////////////////
  // Construct filters object from url hash //
  //////////////////////////////////////////
  function parseParms(urlHash) {
    var pieces = urlHash.substring(1, urlHash.length).replace(/,/g, '').replace(/\s/g, '').split("."),
      i, parts, group, value,
      uniquePieces = [];

    // Remove duplicate value
    $.each(pieces, function (index, word) {
      if ($.inArray(word, uniquePieces) === -1) {
        uniquePieces.push(word);
      }
    });

    // empty object to start clean
    deleteProperties(filters);

    // Process each query pair
    for (i = 0; i < uniquePieces.length; i++) {
      parts = uniquePieces[i].split("__");

      group = decodeURIComponent(parts[0]);
      value = decodeURIComponent(parts[1]);

      // Check if exist
      if ("undefined" === typeof filters[group]) {
        filters[group] = [];
      }

      // Add filters
      filters[group].push('.' + group + '__' + value);
    }

    return filters;
  }


  //////////////
  // URL hash //
  //////////////
  function getHashFilter() {
    // get filter=filterName
    var matches = location.hash.match(/filters=([^&]+)/i);
    var hashFilter = matches ? matches && matches[1] : '';
    return hashFilter && decodeURIComponent(hashFilter);
  }


  ////////////////////////////
  // Init Isotope from Hash //
  ////////////////////////////
  function onHashchange() {

    var isIsotopeInit = false,
      hashFilter = getHashFilter();

    if (!hashFilter && isIsotopeInit) {
      return;
    }

    isIsotopeInit = true;

    // filter isotope
    $container.isotope({
      filter: function () {
        var $this = $(this),
          filterResult = hashFilter ? $this.is(hashFilter) : true;

        return filterResult;
      },
    });

    if (hashFilter) {
      // Parse url and construct 'filters' object for dropdowns
      filters = parseParms(hashFilter);

      // set selected/check for filters
      var activeFilters = hashFilter.replace(/,/g, '').replace(/\s/g, '').split('.'),
        arrayLength = activeFilters.length;

      //------ Set filters item state (active/inactive)
      //reset filters state first
      $filterItem.removeClass('is-active');
      // loop and check/select right filters
      for (var i = 0; i < arrayLength; i++) {
        var $activeFilter = $('a[data-filter=".' + activeFilters[i] + '"]'),
          $activeFilterOptions = $('input[value=".' + activeFilters[i] + '"]');

        $activeFilterOptions.parent().addClass('is-active');
        $activeFilterOptions.prop('checked', true);
        $activeFilter.addClass('is-active');
      }

      // Show reset btn
      $filterReset.addClass('is-visible');

    } else {
      // no-filters, reset filters state to be sure
      $filterItem.removeClass('is-active');
    }

    // Check filtersgroup selection (dropdown/input selection)
    checkFiltersGroup();

    ///////////////////////////
    // on filtering complete //
    ///////////////////////////
    $container.on('arrangeComplete', function () {
      var numItemsDisp = $container.isotope('getFilteredItemElements').length;

      //check if no result, show alert-box
      if (numItemsDisp === 0) {
        $('.js-filtersNoresult').fadeIn();
      } else {
        $('.js-filtersNoresult').hide();
      }
    });
  }


  //////////////////////
  // Clear All filters //
  //////////////////////
  function clearAll() {
    // remove all active filters
    $filterItem.removeClass('is-active');

    // Hide reset btn
    $filterReset.removeClass('is-visible');

    // reset hash / cleanup url
    hashFilter = '';
    window.history.replaceState(null, null, window.location.pathname);

    // Empty filters objects
    deleteProperties(filters);

    // Trigger isotope with hash check
    onHashchange();

    // Reset dropdown text to default label
    $filterLabel.each(function () {
      var $this = $(this);
      $this.text($this.attr('data-label'));
    });

  }

  ///////////////
  // Reset Btn //
  ///////////////
  function resetBtn() {

    // check visibility on page load
    if (hashFilter.length) {
      $filterReset.addClass('is-visible');
    }

    $filterReset.on('click', function () {
      clearAll();
    });
  }

  ////////////////////
  // Clean object   //
  ////////////////////
  function deleteProperties(objectToClean) {
    for (var x in objectToClean) {
      if (objectToClean.hasOwnProperty(x)) {
        delete objectToClean[x];
      }
    }
  }


})(jQuery);



// WEBPACK FOOTER //
// ./scripts/filters.js